import React, { useState } from 'react'
import { Modal, TextInput, Button, FlexRow, Text, Icon } from 'elements'
import ModalContent from '../../app/ModalContent'
import SelectReportSections from './SelectReportSections'
import useReportTemplateUpdate from './hooks/useReportTemplateUpdate'
import { useModalBehavior, useAnalytics } from 'hooks'
import { equalGroups } from '../utils/templates'

export default function EditTemplateModal({ modal, template, defaultReportSections }) {
  const [configSections, setConfigSections] = useState(template.config.sections)
  const [templateName, setTemplateName] = useState(template.name)
  const [submitting, setSubmitting] = useState(false)
  const [updateReportTemplate] = useReportTemplateUpdate()
  const analytics = useAnalytics()

  const defaultTemplate = {
    name: 'default',
    config: {
      sections: [...defaultReportSections.anomalies, ...defaultReportSections.metadata],
    },
  }

  const editing = !equalGroups(configSections, template.config.sections)

  const modalBehavior = useModalBehavior(modal, {
    shouldClose: () => {
      if (editing) {
        return window.confirm('You have unsaved changes. Close anyway?')
      }

      return true
    },
    closingBehavior: modal.closeAllOtherModals,
  })

  const handleUpdate = async () => {
    setSubmitting(true)

    const updated = await updateReportTemplate({
      id: template.id,
      patch: {
        name: templateName,
        config: {
          sections: configSections,
        },
      },
    })

    analytics.track('Report Template Updated', {
      templateId: updated.rowId,
      organizationId: updated.organizationId,
      sectionNames: configSections.map((section) => section.name),
    })

    modal.closeAllOtherModals()
    modal.onClose()
  }

  return (
    <Modal modal={modalBehavior}>
      <FlexRow justifyContent="space-between" px="xlarge" py="small">
        <FlexRow alignItems="center">
          <Text fontWeight="bold" mr="xlarge">
            Template Name:
          </Text>
          <FlexRow>
            <TextInput
              value={templateName}
              onChange={(event) => setTemplateName(event.target.value)}
              placeholder="Template Name"
            />
          </FlexRow>
        </FlexRow>
        <Button kind="transparent" area="xxsmall" onPress={modalBehavior.onClose}>
          <Icon name="x" color="neutral.2" />
        </Button>
      </FlexRow>
      <ModalContent>
        <SelectReportSections
          configSections={configSections}
          setConfigSections={setConfigSections}
          currentTemplate={template}
          defaultReportSections={defaultReportSections}
          defaultTemplate={defaultTemplate}
        />
      </ModalContent>
      <Modal.Footer display="flex" alignItems="center">
        <Button mr="medium" kind="secondary" onPress={handleUpdate}>
          {submitting ? 'Saving...' : 'Save'}
        </Button>
        <Button onPress={modalBehavior.onClose} mr="xxxlarge">
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
